import React, { useEffect } from "react";

import { Box, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import TopBar from "../components/dashboardParts/TopBar";
import { currentUser } from "system/InfegyUser";
import { setDocumentTitle } from "system/Utilities";
import ManageApiTokens from "components/profilePage/ManageApiTokens";

export default function APIHome(): JSX.Element {
  const { i18n } = useTranslation();
  const user = currentUser();

  // Sets document title to default "Infegy Starscape"
  useEffect(() => setDocumentTitle(), []);

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}>
      <Box sx={{ position: "absolute", top: 0, left: 0, width: "100%", zIndex: 100 }}>
        <TopBar showLogo={true} />
      </Box>
      <Box sx={{ width: "100%", maxWidth: "800px", mt: 5, mb: 5, p: 2 }}>
        <Typography variant="h3" sx={{ mt:3, mb:1, fontWeight: "600", opacity: 0.8 }}>
          {i18n.t("manage-api-tokens.heading")}
        </Typography>
        <Paper sx={{ padding: 2, width: "100%"}}>
          {user && <ManageApiTokens user={user} /> }
        </Paper>
      </Box>
    </Box>
  );
}